export default __webpack_public_path__ + "static/media/progress-clock.c9bcc2b8.svg";